import { db } from "../firebase-config";
import { collection, query, onSnapshot, addDoc } from "firebase/firestore";

export const productCategoriesSnapshotListener = (organization, onCategoriesUpdate) => {
    const categoriesQuery = query(collection(db, "organizations", organization, "product_categories"))
    const unsubscribe = onSnapshot(categoriesQuery, (querySnapshot) => {
        const categories = [];
        querySnapshot.forEach((doc) => {
            categories.push({ id: doc.id, ...doc.data() });
        });
        onCategoriesUpdate(categories);
    })
    return () => unsubscribe()
}

export const addCategory = async (organizationId, categoryData) => {
    try {
        const categoriesRef = collection(db, "organizations", organizationId, "product_categories");
        const docRef = await addDoc(categoriesRef, {
            ...categoryData,
            created_at: new Date(),
            updated_at: new Date()
        });
        return { success: true, id: docRef.id };
    } catch (error) {
        console.error("Error adding category:", error);
        return { success: false, error };
    }
};